import styled from 'styled-components';
import SuggestedTimes from 'components/form/SuggestedTimes/container';

export default styled(SuggestedTimes)`
  max-height: 264px;

  overflow: hidden;
  overflow-y: auto;
  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  .suggested-aclaration {
    color: red;
  }
`;
